import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-tenant-api-job-logs',
  templateUrl: './tenant-api-job-logs.component.html',
  styleUrl: './tenant-api-job-logs.component.scss',
})
export class TenantApiJobLogsComponent {
  tenantId?: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const params = this.route.snapshot.params;
    this.tenantId = params['tenantId'];
  }
}
